import { render, staticRenderFns } from "./PetmedServicesChart.vue?vue&type=template&id=485fee3e&scoped=true&"
import script from "./PetmedServicesChart.vue?vue&type=script&lang=js&"
export * from "./PetmedServicesChart.vue?vue&type=script&lang=js&"
import style0 from "./PetmedServicesChart.vue?vue&type=style&index=0&id=485fee3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485fee3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VBtnToggle,VCard,VIcon,VProgressCircular})
